import React from 'react';
import { Box, Flex, Skeleton } from '@skin-seoul/design-system';

export const LoyaltyBannerSkeletonMobile = () => {
  return (
    <Box position="relative" width="100%" height="112px" borderRadius="12px" bg="neutral.100" overflow="hidden">
      <Flex position="relative" height="100%" alignItems="center" justifyContent="space-between" px={4} zIndex={1}>
        {/* Left Side - Title Skeleton */}
        <Flex direction="column" gap={1}>
          <Skeleton height="20px" width="80px" />
          <Skeleton height="20px" width="100px" />
        </Flex>

        {/* Right Side - Points Skeleton */}
        <Skeleton height="32px" width="100px" />
      </Flex>
    </Box>
  );
};
